<p-dropdown [options]="opciones" [(ngModel)]="opcionSeleccionada" (onChange)="onSeleccionarOpcion($event)" placeholder="Seleccione una opción"></p-dropdown>